import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getStateAsync, XeroAsync, QBAsync, setXero, setXeroFromLocalStorage, setQB, setQBFromLocalStorage } from './IntegrationSlice';
import { updateGoogleCalendarTimesheetAutoSync, updateGoogleCalendarTaskAutoSync, updateGoogleCalendarTimesheetManualSync, updateGoogleCalendarTaskManualSync } from '../../../common/GlobalSlice'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import Loader from '../../../common/Loader';
import Select, { components } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { validateSystemIntegration, dropDownSelectionStyles } from '../../../common/timeLiveFunction';
import clsx from 'clsx';

const initialIntegration = {
    QBIsConnected: false,
    QBConsumerKey: '',
    QB_oauth_Callback_Url: '',
    QBstate: '',

    GoogleCalendarIsConnected: false,
    GoogleCalendarClientId: '',
    GoogleCalendarSecret: '',
    GoogleCalendarCallBack: '',
    GoogleCalendarState: '',
    GoogleCalendarSystemIntegrationId: '',
    CommaSeparatedCalendarIds: '',
    GoogleCalendarItems: [],
    IsTask: false,
    IsTaskManual: false,
    IsTimeSheet: false,
    IsTimeSheetManual: false,

    XeroIsConnected: false,
    XeroConsumerKey: '',
    Xero_oauth_Callback_Url: '',
    Xerostate: ''
}

export const Integration = () => {
    const dispatch = useAppDispatch();
    // Xero work commet
    // const { isReload, app, value, IntegrationList, selectedRecord } = useAppSelector((state) => state.integration);
    // const [state, setState] = useState<string>('');
    // const [xero_client_id, setXero_client_id] = useState<string>('');
    // const [xero_callback_uri, setxero_callback_uri] = useState<string>('');
    const { t } = useTranslation();
    // Xero work commet
    // const [IsXeroConnected, setIsXeroConnected] = useState<boolean>(false);
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const ConnectedButtonRef = useRef<any>(null);
    const [googlecalendarItemsArray, SetGooglecalendarItemsArray] = useState<any | ''>([]);
    const navigate = useNavigate();
    // const xero_client_id: string = "B445B0FF506042CA819A022EB22FD484"    
    // const xero_callback_uri: string = "http://localhost:3000/beta/Integrations"

    const googlecalendar_clientId = '746449382374-odim9bg2213d2vtg6uqmsk5atvu8b79g.apps.googleusercontent.com';
    const googlecalendar_callback_uri = 'https://localdebug.livetecs.com/Handler/Integration/GoogleCalendar.ashx';
    const googlecalendar_scope = 'https://www.googleapis.com/auth/calendar';
    const [isIntegerationConnected, setIsIntegerationConnected] = useState(initialIntegration);
    const [isLoading, setIsLoading] = useState(true);
    const { sessionAccountId, sessionAccountEmployeeId } = useAppSelector((state) => state.globalState);
    const location = useLocation();
    // Xero work commet
    // const params = new URLSearchParams(location.search);
    // const appFromUrl = params.get('app');
    // const valueFromUrl = params.get('value');

    useEffect(() => {
        getIntegerationDataAsync();
    }, []);

    useEffect(() => {
        if (isIntegerationConnected.GoogleCalendarIsConnected) {
            if (ConnectedButtonRef.current) {
                ConnectedButtonRef.current.click();
            }
        }
    }, [isIntegerationConnected.GoogleCalendarIsConnected]);

    const getIntegerationDataAsync = async () => {
        try {
            const response: any = await fetchAPI(`api/v2/Integrations/QB/GetAccountIntegerations/${sessionAccountId}/${sessionAccountEmployeeId}`, "GET", "", true);
            const json = await response.json();
            let isQBConnected = json.hasOwnProperty('QBIntegration') ? (json["QBIntegration"].AccessToken != '' ? true : false) : false;
            let isGoogleCalendarConnected = json["GoogleCalendarIntegration"] ? (json["GoogleCalendarIntegration"].AccessToken != '' ? true : false) : false;
            let tempCommaSeparatedCalendarIds = json["GoogleCalendarSettings"].find((item: any) => item.Key === "CommaSeparatedCalendarIds")?.Value;
            let tempGoogleCalendarItems = ((json["GoogleCalendarList"] && json["GoogleCalendarList"].length > 0) ?
                json["GoogleCalendarList"].map((item: any) => {
                    if (tempCommaSeparatedCalendarIds.includes(item.value)) {
                        return { ...item, isSelected: 1 };
                    }
                    return item;
                }) : []);
            let isXeroConnected = json.hasOwnProperty('XeroIntegration') ? (json["XeroIntegration"].AccessToken != '' ? true : false) : false;
            setIsIntegerationConnected({
                ...isIntegerationConnected,
                QBIsConnected: isQBConnected ? validateSystemIntegration(json["QBSettings"].find((item: any) => item.Key === "QBSystemIntegrationId")?.Value.toUpperCase()) === 'Quickbooks' ? true : false : false,
                // QBConsumerKey: isQBConnected ? json["QBSettings"].find((item: any) => item.Key === "QBConsumerKey")?.Value : '',
                // QB_oauth_Callback_Url: isQBConnected ? json["QBSettings"].find((item: any) => item.Key === "QBCallBack")?.Value : '',
                // QBstate: isQBConnected ? json["QBSettings"].find((item: any) => item.Key === "QBState")?.Value : ''
                QBConsumerKey: json.hasOwnProperty('QBSettings') ? json["QBSettings"].find((item: any) => item.Key === "QBConsumerKey")?.Value : '',
                QB_oauth_Callback_Url: json.hasOwnProperty('QBSettings') ? json["QBSettings"].find((item: any) => item.Key === "QBCallBack")?.Value : '',
                QBstate: json.hasOwnProperty('QBSettings') ? json["QBSettings"].find((item: any) => item.Key === "QBState")?.Value : '',
                GoogleCalendarIsConnected: isGoogleCalendarConnected ? validateSystemIntegration(json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarSystemIntegrationId")?.Value.toUpperCase()) === 'GoogleCalendar' ? true : false : false,
                GoogleCalendarClientId: json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarClientId")?.Value,
                GoogleCalendarCallBack: json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarCallBack")?.Value,
                GoogleCalendarState: json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarState")?.Value,
                CommaSeparatedCalendarIds: tempCommaSeparatedCalendarIds,
                GoogleCalendarItems: tempGoogleCalendarItems,
                IsTask: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTask")?.Value,
                IsTaskManual: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTaskManual")?.Value,
                IsTimeSheet: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTimeSheet")?.Value,
                IsTimeSheetManual: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTimeSheetManual")?.Value,
                XeroIsConnected: isXeroConnected ? validateSystemIntegration(json["XeroSettings"].find((item: any) => item.Key === "XeroSystemIntegrationId")?.Value.toUpperCase()) === 'Xero' ? true : false : false,
                XeroConsumerKey: json.hasOwnProperty('XeroSettings') ? json["XeroSettings"].find((item: any) => item.Key === "XeroConsumerKey")?.Value : '',
                Xero_oauth_Callback_Url: json.hasOwnProperty('XeroSettings') ? json["XeroSettings"].find((item: any) => item.Key === "XeroCallBack")?.Value : '',
                Xerostate: json.hasOwnProperty('XeroSettings') ? json["XeroSettings"].find((item: any) => item.Key === "XeroState")?.Value : ''
            });
            dispatch(updateGoogleCalendarTaskAutoSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTask")?.Value));
            dispatch(updateGoogleCalendarTimesheetAutoSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTaskManual")?.Value));
            dispatch(updateGoogleCalendarTaskManualSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTIsTimeSheetask")?.Value));
            dispatch(updateGoogleCalendarTimesheetManualSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTimeSheetManual")?.Value));
            if (json.hasOwnProperty('XeroIntegration')) {
                localStorage.setItem('isXeroConnected', isXeroConnected.toString());
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }

    const updateCalendarIds = async (commaSeparatedCalendarIds: any) => {
        const response = await fetchAPI(`api/v2/Integrations/updateCalendarIds`, 'PUT', { commaSeparatedCalendarIds: commaSeparatedCalendarIds }, true);
    }

    const updateIntegrationSyncAsync = async (checked: boolean, name: string) => {
        const response = await fetchAPI("api/V2/Integrations/updateIntegration/" + checked + "/" + name, "PUT", "", true, "");
    }

    const handlePropertyChange = (selectedOption: any[]) => {
        const values = selectedOption.map((option: any) => option.value.trim());
        // Create a shallow copy of GoogleCalendarItems
        const newState = [...isIntegerationConnected.GoogleCalendarItems];
        // Create a set of the selected values for fast lookup
        const selectedValuesSet = new Set(values);
        // Iterate over each item to update its selection status
        newState.forEach((item: any) => {
            // If the item's value is in the selected values, mark it as selected
            if (selectedValuesSet.has(item.value.trim())) {
                item.isSelected = 1;
            } else {
                // If the item is not in the selected values, unselect it
                item.isSelected = 0;
            }
        });
        let tempCommaSeparatedCalendarIds = newState
            .filter((item: any) => item.isSelected == 1)
            .map((item: any) => item.value)
            .join(',')
        // Update the state with the new state
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            GoogleCalendarItems: newState,
            CommaSeparatedCalendarIds: tempCommaSeparatedCalendarIds
        });
        updateCalendarIds(tempCommaSeparatedCalendarIds);
    }

    const onHandleTaskAutoSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTask: checked
        });
        dispatch(updateGoogleCalendarTaskAutoSync(checked));
        updateIntegrationSyncAsync(checked, "IsTask");
    }

    const onHandleTaskManualSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTaskManual: checked
        });
        dispatch(updateGoogleCalendarTaskManualSync(checked));
        updateIntegrationSyncAsync(checked, "IsTaskManual");
    }

    const onHandleTimesheetAutoSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTimeSheet: checked
        });
        dispatch(updateGoogleCalendarTimesheetAutoSync(checked));
        updateIntegrationSyncAsync(checked, "IsTimeSheet");
    }

    const onHandleTimesheetManualSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTimeSheetManual: checked
        });
        dispatch(updateGoogleCalendarTimesheetManualSync(checked));
        updateIntegrationSyncAsync(checked, "IsTimeSheetManual");
    }
    // Xero work commet
    // useEffect(() => {
    //     let base64String = "";
    //     let jsonString = "";
    //     let jsonObject = "";
    //     let javaobject = null;
    //     if (app && value) {
    //         base64String = value;
    //         jsonString = atob(base64String);
    //         jsonObject = JSON.parse(jsonString);
    //         javaobject = JSON.parse(jsonObject);
    //     }
    //     const XeroIndex = IntegrationList.findIndex(
    //         (item: any) => item.label === "Xero"
    //     );
    //     if (XeroIndex !== -1) {
    //         if (javaobject !== null) {
    //             setIsXeroConnected(javaobject.tenants.length > 0 ? true : false);
    //         }
    //     }
    // }, [app, selectedRecord]);
    // Xero work commet
    // useEffect(() => {
    //     dispatch(getStateAsync())
    //         .unwrap()
    //         .then((originalPromiseResult) => {
    //             setState(originalPromiseResult.state);
    //             setXero_client_id(originalPromiseResult.xero_client_id);
    //             setxero_callback_uri(originalPromiseResult.xero_callback_uri);
    //         })
    //         .catch((rejectedValueOrSerializedError) => {
    //         })
    //     if (appFromUrl && valueFromUrl) {
    //         if (appFromUrl === 'Xero') {
    //             dispatch(setXero({ appFromUrl, valueFromUrl }));
    //         }
    //     }
    //     else {
    //         const storedXeroObject = localStorage.getItem('Xero');
    //         const XeroData = (storedXeroObject && storedXeroObject !== 'undefined') ? JSON.parse(storedXeroObject) : null;
    //         if (XeroData) {
    //             dispatch(setXeroFromLocalStorage(XeroData));
    //         }
    //     }
    // }, []);

    // useEffect(() => {
    //     if (isReload) {
    //         dispatch(getStateAsync())
    //             .unwrap()
    //             .then((originalPromiseResult) => {
    //                 //console.log('state:', originalPromiseResult);
    //                 setState(originalPromiseResult);
    //                 //console.log('onDeleteClick-DeleteSelectedAccountLocationAsync-originalPromiseResult', originalPromiseResult);
    //             })
    //             .catch((rejectedValueOrSerializedError) => {
    //                 //console.log('onDeleteClick-DeleteSelectedAccountLocationAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
    //             })
    //     }
    // }, [isReload])

    // useEffect(() => {
    //     dispatch(getStateAsync())
    //         .unwrap()
    //         .then((originalPromiseResult) => {
    //            // console.log('state:', originalPromiseResult);
    //             setState(originalPromiseResult);
    //             //console.log('onDeleteClick-DeleteSelectedAccountLocationAsync-originalPromiseResult', originalPromiseResult);
    //         })
    //         .catch((rejectedValueOrSerializedError) => {
    //             //console.log('onDeleteClick-DeleteSelectedAccountLocationAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
    //         })
    //       //  console.log("IntegrationList:",IntegrationList);
    // }, [dispatch])

    return (
        <>
            {isLoading && <Loader />}
            {/* QuickBooks */}
            <div className="card card-custom" >
                <div className="card-header" style={{ paddingLeft: '0px' }}>
                    <h3 className="card-title fw-bold headerTitle pl-0">{t('Integrations')}</h3>
                    <div className="card-toolbar">
                    </div>
                </div>
                <div className='row' style={{ padding: '20px 30px' }}>
                    <div className="col-md-3">
                        <div className='card card-custom Quickbooks card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(178 233 178 / 30%)' }}>
                            <div className="card-header" style={{ borderBottom: '1px solid #d7cbcb63' }}>
                                <h3 className="card-title Qb">  {t('QuickBooks')}</h3>
                                <div className="card-toolbar">
                                    <img src={toAbsoluteUrl('/media/logos/integrations/qb.png')} />
                                </div>
                            </div>
                            <div className="card-body" style={{ height: '120px', overflow: 'scroll' }}>
                                {isIntegerationConnected.QBIsConnected ?
                                    <p className="connected Qb"  ><i className="fa fa-check" aria-hidden="true" style={{ color: 'darkgreen', fontSize: '20px' }}></i>&nbsp;  {t("You 're connected")} </p>
                                    :
                                    null
                                }
                                <p className="desc">  {t('You need QuickBooks accounting software to keep your books accurate and up to date, automatically.')}</p>
                            </div>
                            <div className="card-footer footer-border">
                                {!isIntegerationConnected.QBIsConnected ?
                                    <a
                                        style={{
                                            display: "inline-block",
                                            padding: "10px 20px",
                                            color: "#fff",
                                            backgroundColor: "#2ca01c",
                                            borderRadius: "5px",
                                            textDecoration: "none",
                                            textAlign: "center",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease"
                                        }}
                                        href={`https://appcenter.intuit.com/connect/oauth2?client_id=${isIntegerationConnected.QBConsumerKey}&response_type=code&scope=com.intuit.quickbooks.accounting%20openid&redirect_uri=${isIntegerationConnected.QB_oauth_Callback_Url}&state=${isIntegerationConnected.QBstate}`}>
                                        {t('Connect to QuickBooks')}
                                    </a>
                                    // <Link to={`https://appcenter.intuit.com/connect/oauth2?client_id=${isIntegerationConnected.QBConsumerKey}&response_type=code&scope=com.intuit.quickbooks.accounting%20openid&redirect_uri=${isIntegerationConnected.QB_oauth_Callback_Url}&state=${isIntegerationConnected.QBstate}`}
                                    //     className='btn btn-sm'
                                    //     style={{ background: '#2ca01c', color: 'white' }}
                                    // >
                                    //     <span style={{ verticalAlign: '0.2em' }}>{t('Connect to QuickBooks')}</span>
                                    // </Link>
                                    :
                                    <a
                                        style={{
                                            display: "inline-block",
                                            padding: "10px 20px",
                                            color: "#fff",
                                            backgroundColor: "#2ca01c",
                                            borderRadius: "5px",
                                            textDecoration: "none",
                                            textAlign: "center",
                                            cursor: "pointer",
                                            transition: "background-color 0.3s ease"
                                        }}
                                        onClick={() => {
                                            navigate('/accountQBonline');
                                        }}>
                                        {t('Connected. Click to Sync')}
                                    </a>
                                    // <Link to={`../accountQBonline`}
                                    //     className='btn btn-sm'
                                    //     style={{ background: '#2ca01c', color: 'white' }} >
                                    //     <span style={{ verticalAlign: '0.2em' }}>{t('Connected. Click to Sync')}</span>
                                    // </Link>
                                }
                            </div>
                        </div>
                    </div>
                    {/* Xero */}
                    <div className="col-md-3">
                        <div className='card card-custom card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(208 239 246 / 55%)' }}>
                            <div className="card-header" style={{ borderBottom: '1px solid rgb(0 0 0 / 10%)' }}>
                                <h3 className="card-title Zr">{t('Xero')}</h3>
                                <div className="card-toolbar">
                                    <img className='border-int' src={toAbsoluteUrl('/media/logos/integrations/xero.png')} />
                                    {/* <img src="../img/integrations/xero.png" /> */}
                                </div>
                            </div>
                            <div className="card-body flow" style={{ height: '120px' }}>
                                {/* Xero work commet */}
                                {/* {IsXeroConnected ?
                                    <p className="connected Zr"><i className="fa fa-check" style={{ color: '#27859b', fontSize: '20px' }} aria-hidden="true"> </i>&nbsp;{t("You 're connected")} </p>
                                    :
                                    null
                                } */}
                                {isIntegerationConnected.XeroIsConnected ?
                                    <p className="connected Zr" ><i className="fa fa-check" aria-hidden="true" style={{ color: '#27859b', fontSize: '20px' }}></i>&nbsp;{t("You 're connected")} </p>
                                    :
                                    null
                                }
                                <p className="desc"> {t('Xero is a cloud-based accounting software platform for small and medium-sized businesses.')}</p>
                            </div>
                            <div className="card-footer footer-border">
                                {/* Xero work commet */}
                                {/* {!IsXeroConnected ?
                                    <Link to={`https://login.xero.com/identity/connect/authorize?client_id=${xero_client_id}&redirect_uri=${xero_callback_uri}&scope=offline_access accounting.transactions openid profile email accounting.contacts accounting.settings accounting.transactions.read projects projects.read&response_type=code&state=${state}`}
                                        className='btn btn-sm'
                                        style={{ background: '#00b7e2', color: 'white' }}
                                    >
                                        <span style={{ verticalAlign: '0.2em' }}>  {t('Connect to Xero')}</span>
                                    </Link>
                                    :
                                    <Link to={``}
                                        className='btn btn-sm'
                                        style={{ background: '#00b7e2', color: 'white' }}
                                    >
                                        <span style={{ verticalAlign: '0.2em' }}> {t('Connected')}</span>
                                    </Link>
                                } */}
                                {!isIntegerationConnected.XeroIsConnected ?
                                    <Link to={`https://login.xero.com/identity/connect/authorize?client_id=${isIntegerationConnected.XeroConsumerKey}&redirect_uri=${isIntegerationConnected.Xero_oauth_Callback_Url}&scope=offline_access accounting.transactions openid profile email accounting.contacts accounting.settings accounting.transactions.read projects projects.read&response_type=code&state=${isIntegerationConnected.Xerostate}`}
                                        className='btn btn-sm'
                                        style={{ background: '#00b7e2', color: 'white' }}
                                    >
                                        <span style={{ verticalAlign: '0.2em' }}>  {t('Connect to Xero')}</span>
                                    </Link>
                                    :
                                    <Link to={``}
                                        className='btn btn-sm'
                                        style={{ background: '#00b7e2', color: 'white' }}
                                    >
                                        <span style={{ verticalAlign: '0.2em' }}> {t('Connected')}</span>
                                    </Link>
                                }
                            </div>
                        </div>
                    </div>
                    {/* Zapier */}
                    <div className="col-md-3">
                        <div className='card card-custom card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(252 148 103 / 13%)' }}>
                            <div className="card-header" style={{ borderBottom: '1px solid rgb(0 0 0 / 10%)' }}>
                                <h3 className="card-title Zp">{t('Zapier')}</h3>
                                <div className="card-toolbar">
                                    <img className='border-int' src={toAbsoluteUrl('/media/logos/integrations/zapier.png')} />
                                </div>
                            </div>
                            <div className="card-body flow" style={{ height: '120px' }}>
                                {/* {IsXeroConnected ?
                                    <p className="connected Zp"><i className="fa fa-check" style={{ color: '#ba4513', fontSize: '20px' }} aria-hidden="true"> </i>&nbsp;{t("You 're connected")} </p>
                                    :
                                    null
                                } */}
                                <p className="desc"> {t('The one app to rule them all! Use this Integration to create a delayed trigger or stay in the know about new supported apps, triggers and actions.')}</p>
                            </div>
                            <div className="card-footer footer-border">
                                {/* <Link to={`../accountZapierOnline`}
                                className='btn btn-sm'
                                style={{ background: '#f64e07', color: 'white' }}
                            >
                                <span style={{ verticalAlign: '0.2em' }}>Connect to Zapier</span>
                            </Link> */}
                                <a
                                    href="../accountZapierOnline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm"
                                    style={{ background: '#f64e07', color: 'white' }}
                                >
                                    <span style={{ verticalAlign: '0.2em' }}> {t('Connect to Zapier')}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* JIRA */}
                    <div className="col-md-3">
                        <div className='card card-custom card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(128 174 241 / 27%)' }}>
                            <div className="card-header" style={{ borderBottom: '1px solid rgb(0 0 0 / 10%)' }}>
                                <h3 className="card-title Jr">{t('JIRA')} </h3>
                                <div className="card-toolbar">
                                    <img className='border-int' src={toAbsoluteUrl('/media/logos/integrations/jira.png')} />
                                    {/* <img src="../img/integrations/jira.png" /> */}
                                </div>
                            </div>
                            <div className="card-body flow" style={{ height: '120px' }}>
                                {/* {IsXeroConnected ?
                                    <p className="connected Jr"><i className="fa fa-check" style={{ color: '#104a9b', fontSize: '20px' }} aria-hidden="true"> </i>&nbsp;{t("You 're connected")} </p>
                                    :
                                    null
                                } */}
                                <p className="desc"> {t('Jira Software is built for every member of your software team to plan, track, and release great software.')}</p>
                            </div>
                            <div className="card-footer footer-border">
                                {/* <Link to={`https://www.livetecs.com/timelivexhelp/1/en/topic/configuring-jira-integration`}
                                className='btn btn-sm'
                                style={{ background: '#0b5ed4', color: 'white' }}
                            >
                                <span style={{ verticalAlign: '0.2em' }}>Integrate with JIRA</span>
                            </Link> */}
                                <a
                                    href="https://www.livetecs.com/timelivexhelp/1/en/topic/configuring-jira-integration"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm"
                                    style={{ background: '#0b5ed4', color: 'white' }}
                                >
                                    <span style={{ verticalAlign: '0.2em' }}> {t('Integrate with JIRA')}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row' style={{ padding: '0px 30px' }}>
                    {/* Webhooks */}
                    <div className="col-md-3">
                        <div className='card card-custom card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(244 211 221 / 26%)' }}>
                            <div className="card-header" style={{ borderBottom: '1px solid rgb(0 0 0 / 10%)' }}>
                                <h3 className="card-title Wb"> {t('Webhooks')}</h3>
                                <div className="card-toolbar">
                                    <img className='border-int' src={toAbsoluteUrl('/media/logos/integrations/webhooks.png')} />
                                    {/* <img src="../img/integrations/webhooks.png" /> */}
                                </div>
                            </div>
                            <div className="card-body flow" style={{ height: '120px' }}>
                                {/* {IsXeroConnected ?

                                    <p className="connected Wb"><i className="fa fa-check" style={{ color: '#a4143e', fontSize: '20px' }} aria-hidden="true"> </i>&nbsp;{t("You 're connected")} </p>
                                    :
                                    null
                                } */}
                                <p className="desc"> {t("Webhooks are one way that apps can send automated information to other apps. Check the Statuses of your Account's History.")}</p>
                            </div>
                            <div className="card-footer footer-border">
                                {/* <Link to={`../webhooks`}
                                className='btn btn-sm'
                                style={{ background: '#c13860', color: 'white' }}
                            >
                                <span style={{ verticalAlign: '0.2em' }}>Get Started</span>
                            </Link> */}
                                <a
                                    href="../webhooks"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm"
                                    style={{ background: '#c13860', color: 'white' }}
                                >
                                    <span style={{ verticalAlign: '0.2em' }}> {t('Get Started')}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* REST API */}
                    <div className="col-md-3">
                        <div className='card card-custom card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(70 169 208 / 20%)' }}>
                            <div className="card-header" style={{ borderBottom: '1px solid rgb(0 0 0 / 10%)' }}>
                                <h3 className="card-title Ra"> {t('REST API')}</h3>
                                <div className="card-toolbar">
                                    <img className='border-int' src={toAbsoluteUrl('/media/logos/integrations/rest-api.png')} style={{ width: '63', height: '56' }} />
                                </div>
                            </div>
                            <div className="card-body flow" style={{ height: '120px' }}>
                                {/* {IsXeroConnected ?

                                    <p className="connected Ra"><i className="fa fa-check" style={{ color: '#0f6f85', fontSize: '20px' }} aria-hidden="true"> </i>&nbsp;{t("You 're connected")} </p>
                                    :
                                    null
                                } */}
                                <p className="desc"> {t('HTTP requests from other Applications to your Account using Application program interface (API).')}</p>
                            </div>
                            <div className="card-footer footer-border">
                                <a
                                    href="https://www.livetecs.com/timelivexhelp/1/en/topic/timelive-api-authentication"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm"
                                    style={{ background: 'rgb(11 114 152)', color: 'white' }}
                                >
                                    <span style={{ verticalAlign: '0.2em' }}>  {t('View Docs')}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-3">
                        <div className='card card-custom card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(255 222 126 / 20%)' }}>
                            <div className="card-header" style={{ borderBottom: '1px solid rgb(0 0 0 / 10%)' }}>
                                <h3 className="card-title Gc"> {t('Google Calendar')}</h3>
                                <div className="card-toolbar">
                                    <img src={toAbsoluteUrl('/media/logos/integrations/g-calendar.png')} />
                                </div>
                            </div>
                            <div className="card-body" style={{ height: '120px', overflow: 'scroll' }}>
                                {isIntegerationConnected.GoogleCalendarIsConnected &&
                                    <>
                                        <div style={{ float: 'right' }}>
                                            <div className={clsx('cursor-pointer symbol')}
                                                data-kt-menu-trigger="{default: 'click'}"
                                                data-kt-menu-attach='parent'
                                                data-kt-menu-placement='bottom-end'
                                            >
                                                <span
                                                    className={`btn btn-icon btn-active-light-dark '}   btn-sm ms-0 fs-7`}
                                                    data-tooltip-id="tooltip-Description"
                                                    data-tooltip-content="Integration Settings"
                                                    data-tooltip-place="bottom"
                                                >
                                                    <i className="bi bi-gear fs-3 Gc" ></i>
                                                </span>
                                            </div>
                                            <div className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary py-4 fs-6 w-350px`}
                                                data-kt-menu='true'
                                            >
                                                <div className={"row tsDescriptionWidget "}>
                                                    <div className={"col-md-12 col-sm-12 col-xs-12"}>
                                                        <h4 className="card-title fw-bold titleHeading">{t(`Integration Settings`)}</h4>
                                                        <div className="separator my-2"></div>
                                                        <div className="mb-2 col-md-12 col-xs-12">
                                                            <div className="row col-md-12 col-xs-12 mb-1">
                                                                <div className="col-md-9">
                                                                    <label className="fs-7 fs-7 fw-normal">Calendar List</label>
                                                                </div>
                                                            </div>
                                                            <Select
                                                                value={isIntegerationConnected.GoogleCalendarItems.filter((item: any) => item.isSelected == 1).map((item: any) => ({ value: item.value, label: item.label }))}
                                                                closeMenuOnSelect={false}
                                                                options={isIntegerationConnected.GoogleCalendarItems}
                                                                isMulti
                                                                onChange={(selectedOptions: any) =>
                                                                    handlePropertyChange(selectedOptions)
                                                                }
                                                                components={{ MultiValue }}
                                                                hideSelectedOptions={false}
                                                                styles={dropDownSelectionStyles}
                                                                maxMenuHeight={maxMenuHeight}
                                                            />
                                                        </div>
                                                        <span className='fw-bold'>{t(`Timesheet`)}</span>
                                                        <div className="separator my-2"></div>
                                                        <div className="row mb-2 col-md-12">
                                                            <div className='col-md-6'>
                                                                <label className="fs-7 fs-7 fw-normal mb-1">{t('Auto')}</label>
                                                                <div className={"form-group"}>
                                                                    <div className="form-check form-switch form-check-custom">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                                            checked={isIntegerationConnected.IsTimeSheet}
                                                                            onChange={(e) => { onHandleTimesheetAutoSync(e) }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <label className="fs-7 fs-7 fw-normal mb-1">{t('Manual')}</label>
                                                                <div className={"form-group"}>
                                                                    <div className="form-check form-switch form-check-custom">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                                            checked={isIntegerationConnected.IsTimeSheetManual}
                                                                            onChange={(e) => { onHandleTimesheetManualSync(e) }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span className='fw-bold'>{t(`Task`)}</span>
                                                        <div className="separator my-2"></div>
                                                        <div className="row mb-2 col-md-12">
                                                            <div className='col-md-6'>
                                                                <label className="fs-7 fs-7 fw-normal mb-1">{t('Auto')}</label>
                                                                <div className={"form-group"}>
                                                                    <div className="form-check form-switch form-check-custom">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                                            checked={isIntegerationConnected.IsTask}
                                                                            onChange={(e) => { onHandleTaskAutoSync(e) }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col-md-6'>
                                                                <label className="fs-7 fs-7 fw-normal mb-1">{t('Manual')}</label>
                                                                <div className={"form-group"}>
                                                                    <div className="form-check form-switch form-check-custom">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input custom-padding-right h-15px w-30px"
                                                                            checked={isIntegerationConnected.IsTaskManual}
                                                                            onChange={(e) => { onHandleTaskManualSync(e) }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <p className="connected Gc">
                                            <i className="fa fa-check Gc" style={{ color: '#0f6f85', fontSize: '20px' }} aria-hidden="true"> </i>&nbsp;{t("You 're connected")}
                                        </p>
                                    </>
                                }
                                <p className="desc"> {t('Google Calendar lets you organize your Company schedule and share events with co-workers and Employees.')}</p>
                            </div>
                            <div className="card-footer">
                                {!isIntegerationConnected.GoogleCalendarIsConnected ?
                                    <Link to={`https://accounts.google.com/o/oauth2/v2/auth?client_id=${isIntegerationConnected.GoogleCalendarClientId}&redirect_uri=${isIntegerationConnected.GoogleCalendarCallBack}&response_type=code&scope=${googlecalendar_scope}&access_type=offline&include_granted_scopes=true&state=${isIntegerationConnected.GoogleCalendarState}&prompt=consent`}
                                        className='btn btn-sm'
                                        style={{ background: 'rgb(117 87 0 / 79%)', color: 'white', opacity: '0.7' }}
                                    >
                                        <span style={{ verticalAlign: '0.2em' }}>  {t('Connect to Google Calendar')}</span>
                                    </Link>
                                    :
                                    <Link to={``}
                                        className='btn btn-sm'
                                        style={{ background: 'rgb(117 87 0 / 79%)', color: 'white', opacity: '0.7' }}
                                        ref={ConnectedButtonRef}
                                    >
                                        <span style={{ verticalAlign: '0.2em' }}> {t('Connected')}</span>
                                    </Link>
                                }
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </>
    )
}

const MultiValue = ({ index, getValue, ...props }: any) => {
    const maxToShow = 0;
    const overflow = getValue()
        .slice(maxToShow)
        .map((x: any) => x.label);
    return index < maxToShow ? (
        <components.MultiValue {...props} />
    ) : index === maxToShow ? (
        <>
            <MoreSelectedBadge items={overflow} totalItemCount={props.options.length} />
        </>
    ) : null;
};
const MoreSelectedBadge = ({ items, totalItemCount }: any) => {
    const style = {
        background: "#d4eefa",
        borderRadius: "4px",
        fontSize: "12px",
        padding: "5px"
    };
    const title = items.join(", ");
    const length = items.length;
    const label = length === totalItemCount ? `All Selected(${length})` : ` ${length} Item${length !== 1 ? "s" : ""} Selected`;
    return (
        <div style={style} title={title}>
            {label}
        </div>
    );
};